<div class="p-grid">
  <div class="p-col-12 mu-password-checker-bar">
    <div id="mu-password-checker-bar-progress"></div>
  </div>
  <div class="p-col-12 mu-password-checker-text">
    <i class="fas fa-warning" id="mu-password-checker-icon" aria-hidden="true"></i>
    <span id="mu-password-checker-text" id="mu-password-checker-text">{{ 'mu-password-checker-text' | translate }}</span>
  </div>
</div>
